import React, { useState } from 'react';
import './FAQ.css';

const FAQ: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: "What types of content can I use with AInstein?",
      answer: "AInstein supports various content types including PDFs, photos, YouTube videos, and audio files. Simply upload or link your content, and we'll transform it into interactive learning materials."
    },
    {
      question: "How does the spaced repetition system work?",
      answer: "Our smart spaced repetition algorithm tracks your progress and schedules review sessions at optimal intervals to enhance long-term retention. It automatically adjusts based on your performance and confidence levels."
    },
    {
      question: "Can I track my learning progress?",
      answer: "Yes, AInstein provides detailed insights into your learning journey. You can monitor your strengths, areas for improvement, and overall progress through intuitive dashboards and analytics."
    },
    {
      question: "What kind of learning materials can AInstein generate?",
      answer: "AInstein can create comprehensive lessons, interactive quizzes, and digital flashcards from your uploaded content, making it easier to study and retain information effectively."
    },
    {
      question: "Is my study data secure?",
      answer: "Absolutely. We prioritize your privacy and security. Your uploaded content and learning data are encrypted and stored securely, and we never share your information with third parties."
    }
  ];

  const toggleAccordion = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <div className="container">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-container">
          {faqs.map((faq, index) => (
            <div key={index} className={`faq-item ${activeIndex === index ? 'active' : ''}`}>
              <button 
                className="faq-question"
                onClick={() => toggleAccordion(index)}
                style={{
                  alignItems: 'center',
                  fontSize: '16px',
                  fontWeight: 500,
                }}
              >
                <span>{faq.question}</span>
                <i className={`fas fa-chevron-${activeIndex === index ? 'up' : 'down'}`}></i>
              </button>
              <div className="faq-answer" style={{ maxHeight: activeIndex === index ? '200px' : '0' }}>
                <div className="faq-answer-content">{faq.answer}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
